import Keykcloak from 'keycloak-js';

const keyclock = new Keykcloak({
  url: window.ENV.REACT_APP_KEYCLOAK_URL || '',
  realm: window.ENV.REACT_APP_KEYCLOAK_REALM || '',
  clientId: window.ENV.REACT_APP_KEYCLOAK_CLIENTID || '',
});

export default keyclock;